import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/useAppStore';
import { useRole } from '../../hooks/useRole';
import { getVisibleClientOrders } from '../../utils/orderUtils';
import CustomerOrderCard from './CustomerOrderCard';

function CustomerQueue() {
  const { t } = useTranslation();
  const role = useRole();
  const orders = useAppStore((state) => state.orders);
  const statusMessage = useAppStore((state) => state.statusMessage);
  const errorMessage = useAppStore((state) => state.errorMessage);

  const visibleOrders = useMemo(() => getVisibleClientOrders(orders), [orders]);

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-xl font-bold">{t('cq.title')}</h2>
        <p className="mt-0.5 text-sm theme-muted">{t('cq.subtitle')}</p>
      </div>

      {role === 'anonymous' && (
        <p className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-2.5 text-sm theme-accent-warm">
          {t('menu.joinSession')}
        </p>
      )}

      {statusMessage && (
        <p className="rounded-md border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm theme-accent">
          {statusMessage}
        </p>
      )}
      {errorMessage && (
        <p className="rounded-md border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm theme-accent-danger">
          {errorMessage}
        </p>
      )}

      {visibleOrders.length === 0 ? (
        <p className="text-sm theme-muted">{t('cq.empty')}</p>
      ) : (
        <div className="space-y-2">
          {visibleOrders.map((order) => (
            <CustomerOrderCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomerQueue;
